import { ProviderConfig, ProviderTypes } from 'types';
import { VerizonTheme } from 'config/themes';

export const VerizonFWA: ProviderConfig = {
  providerType: ProviderTypes.WISP,
  providerCode: 'verizonfwa',
  dcCode: 'VerizonFWA',
  name: 'Verizon FWA',
  displayName: 'Verizon FWA',
  reskinTheme: VerizonTheme,
  reskinTitle: 'Verizon Authorized Dealer',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'linkout_url',
};
